module.exports = __webpack_public_path__ + "static/media/25_A.b8e681d3.png";